export default "__VITE_ASSET__CcQza8x5__"